<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboard" name="Dashboard" icon="ti-panel" />
       <!-- <sidebar-link to="/stats" name="Perfil de Usuario" icon="ti-user" />-->
        <sidebar-link v-if="role === 3 || role === 1" to="/informes" name="Informes" icon="ti-bookmark-alt" />
        <sidebar-link v-if="role === 2 || role === 1 || role === 4" to="/upVideo" name="Videos" icon="ti-cloud-up" />
       <sidebar-link v-if="role === 4 || role === 1" to="/GeoMap" name="Maps" icon="ti-map"></sidebar-link>
       <!--
        <sidebar-link
          to="/table-list"
          name="Table List"
          icon="ti-view-list-alt"
        />
        -->
        <!--<sidebar-link to="/typography" name="Typography" icon="ti-text" />-->
        <sidebar-link
          v-if="role === 3 || role === 1"
          to="/Visualizar"
          name="Ver videos"
          icon="ti-video-clapper"
        />
        <sidebar-link v-if="role === 3 || role === 1" to="/informepreliminar" name ="informe preliminar" icon="ti-clipboard"/>
        <sidebar-link
          v-if="role === 3 || role === 1 || role === 4"
          to="/Informediario"
          name="Informe diario"
          icon="ti-pencil-alt"
        />
        <sidebar-link
          v-if="role === 3 || role === 1 || role === 4"
          to="/CatastroUD"
          name="Catastro UD"
          icon="ti-pencil-alt"
        />
        <sidebar-link v-if="role ===1" to="/VistaCatastro" name="Vista catastro" icon="ti-desktop">

        </sidebar-link>
       <!-- <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2" />-->
        <!--
        <sidebar-link to="/maps" name="Map" icon="ti-map" />
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell" />
        -->
      </template>
      <mobile-menu>
        <!--
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down
          class="nav-item"
          title="5 Notifications"
          title-classes="nav-link"
          icon="ti-bell"
        >
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-settings"></i>
            <p>Settings</p>
          </a>
        </li>
        -->
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
/* eslint-disable no-console */
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import store from "../../store";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data: () => ({
    role: ""
  }),
  created() {
    if (store.state.User.CurrentUser === "") {
      this.$router.push("/");

    }
    this.role = store.state.User.CurrentUser.role_id;
  },
  mounted() {},
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
